import { normalizeEngineToConnectionType } from 'Utils';

function stripForCompare(s) {
  return String(s || '')
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '');
}

/**
 * Map connection engine and driver "Database" labels to one comparable key
 * so installed JDBC drivers can be matched to masking list rows.
 */
export function canonicalMaskingDbKey(engineOrLabel) {
  if (!engineOrLabel) return '';
  const raw = String(engineOrLabel).trim().toLowerCase();
  if (!raw) return '';

  const hyphenFixed = normalizeEngineToConnectionType(raw) || raw;
  let compact = stripForCompare(hyphenFixed);
  const compactAliases = {
    aurorapostgresql: 'postgresql',
    oracleee: 'oracledb',
    microsoftsqlserver: 'mssql',
    amazonredshift: 'redshift',
    postgres: 'postgresql',
  };
  if (compactAliases[compact]) return compactAliases[compact];
  return compact;
}

/**
 * True when some installed driver supports masking for this engine/database type.
 * mongodb short-circuits to true: mongo masking goes through the masking-service's native
 * MongoDB driver, not a JDBC driver, so there is never a registry row to match against.
 * (Encryption lists never contain mongo rows, so this bypass only affects masking.)
 * dynamodb deliberately does NOT get the bypass: dynamo can't be masked at all (the
 * platform rejects it with ENGINE_NOT_MASKABLE), so the Mask button must stay disabled —
 * falling through to the registry match correctly yields false (no JDBC driver exists).
 */
export function hasMaskingDriverForEngine(engine, drivers) {
  if (canonicalMaskingDbKey(engine) === 'mongodb') return true;
  if (!Array.isArray(drivers) || drivers.length === 0) return false;
  const sourceKey = canonicalMaskingDbKey(engine);
  if (!sourceKey) return false;
  return drivers.some(
    (d) =>
      d &&
      d.maskingAvailable &&
      canonicalMaskingDbKey(d.database) === sourceKey
  );
}
